import { Itinerary2 } from '~/models/Itinerary'
import { Lead } from '~/models/Lead'
import { Site2 } from '~/models/Site'
import { Spot2 } from '~/models/Spot'
import { LeadRepository } from './repository'

export class LeadService {
	static async sendEmail(
		lead: Lead,
		site: Site2,
		spots?: Spot2[],
		itinerary?: Record<string, Spot2[]>,
		title?: string,
		assistantName?: string
	): Promise<string> {
		return await LeadRepository.sendEmail(lead, site, spots, itinerary, title, assistantName)
	}

	static async getSpots(leadId: string): Promise<Spot2[]> {
		return await LeadRepository.getSpots(leadId)
	}

	static async getItinerary(leadId: string): Promise<Record<string, Spot2[]>> {
		return await LeadRepository.getItinerary(leadId)
	}

	static async createTrip(leadId: string): Promise<Itinerary2> {
		return await LeadRepository.createTrip(leadId)
	}
}
